module.exports = __webpack_public_path__ + "assets/img/live2.22cb27cd.png";